import { createTheme as o } from "./highrise984.mjs";
import e from "./highrise1027.mjs";
import i from "./highrise987.mjs";
const p = o({
  name: "Ellipsis",
  common: i,
  peers: {
    Tooltip: e
  }
});
export {
  p as default
};
